import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Home.scss';
import UserHome from '../../components/User/UserHome/UserHome';

class home extends Component {

    render() {
          return (
              <React.Fragment>
                {/* {
                    this.props.isLoggedIn ? 
                    <div className={classes.Wrapper}>
                        <UserHome/>
                    </div>
                    :
                    <div className={classes.Home}></div> 
                } */}
                <div className={classes.Home}></div>
              </React.Fragment>
        );
    }
} 

const mapStateToProps = state => {
    return {
        isLoggedIn: state.auth.isLoggedIn
    }
}

export default connect(mapStateToProps)(home);


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js